import { ALL_USER_ROLES, ROLES } from "@/consts";

export default [
  {
    path: "auth-prompt",
    component: () =>
      import(/* webpackChunkName: "auth-prompt" */ "@/views/Auth/AuthPrompt"),
    name: "AuthPrompt",
    meta: { title: "我的订单", topbarHidden: true },
  },
  {
    path: "customer-detail",
    component: () =>
      import(
        /* webpackChunkName: "customer-detail" */ "@/views/Common/CustomerDetail"
      ),
    name: "CustomerDetail",
    meta: { title: "我的顾客", accessRoles: ALL_USER_ROLES, withTabbar: false },
  },
  {
    path: "adjust-price",
    component: () =>
      import(
        /* webpackChunkName: "store-manager-dashboard" */ "@/views/Common/AdjustPrice"
      ),
    name: "AdjustPrice",
    meta: {
      title: "调价审批",
      accessRoles: ALL_USER_ROLES,
      withTabbar: false,
    },
  },
  {
    path: "adjust-price-list",
    component: () =>
      import(
        /* webpackChunkName: "store-manager-dashboard" */ "@/views/Common/AdjustPriceList"
      ),
    name: "AdjustPriceList",
    meta: {
      title: "调价审批",
      accessRoles: ALL_USER_ROLES,
      withTabbar: false,
    },
  },
  {
    path: "select-store",
    component: () =>
      import(
        /* webpackChunkName: "select-store" */ "@/views/Common/SelectStore"
      ),
    name: "SelectStore",
    meta: {
      title: "选择门店",
      accessRoles: [ROLES.CLIENT_AGENT, ROLES.STORE_MANAGER],
      topbarHidden: true,
    },
  },
  {
    path: "logistics",
    component: () =>
      import(/* webpackChunkName: "logistics" */ "@/views/Common/Logistics"),
    name: "Logistics",
    meta: {
      title: "物流详情",
      accessRoles: [...ALL_USER_ROLES, ROLES.CUSTOMER],
      topbarHidden: false,
    },
  },
];
